<template>
  <div class="agent-detials">
    <div class="top-container">
      <div class="operation">
        <p class="code">单据号：{{billCode}}</p>
        <div>
          <span>打印凭证预览：</span>
          <img @click="printPreview" class="print-sign" src="../../../../assets/finance/print.png">
        </div>
        <div class="operation-right">
          <div class="operation-right-row">
            <p class="row-title">状态</p>
            <p  class="row-content">{{statusVal}}</p>
          </div>
          <div class="operation-right-row">
            <p class="row-title">合计金额</p>
            <p class="row-content row-amount">￥{{amount}}</p>
          </div>
          <div class="operation-right-row">
            <p class="row-title">核准金额</p>
            <p class="row-content row-amount">￥{{allApprovedAmount}}</p>
          </div>
        </div>
      </div>
      <div class="info-container">
        <div class="info-container-left"  v-if="orderType == 1">
          <div class="info-container-left-row">
            <p class="row-info">类型：{{reimbursementFormName}}</p>
            <div class="row-info" >
              单据张数：{{billNum}}
            </div>
            <div class="row-info">
              补齐资料：
              <el-button type="text" class="btn-text" @click="lookImg(supplementDataImgList)"
                >详情</el-button
              >
            </div>
            <div class="row-info bank-deposit">
              <div class="bank-content">
                <span class="row-bank">银行存款：</span>
                <span class="row-bank">{{bankAmount}}</span>
              </div>
            </div>

          </div>
          <div class="info-container-left-row">
            <p class="row-info">单位：{{deptName}}</p>
            <p class="row-info">验收人：{{acceptorName}}</p>
            <div class="row-info">
              上会资料：
              <el-button type="text" class="btn-text" @click="lookImg(subDataImgList)"
                >详情</el-button
              >
            </div>
            <div class="row-info bank-deposit">
              <div class="bank-content">
                <span class="row-bank">经费类型：</span>
                <span class="row-bank">{{reimbursementTypeDesc}}</span>
              </div>
            </div>
          </div>
          <div class="info-container-left-row">
            <p class="row-info">日期：{{date}}</p>
            <p class="row-info">是否上会：{{isSub}}</p>
          </div>
        </div>

        <div class="info-container-left" v-if="orderType == 3">
          <div class="info-container-left-row">
            <p class="row-info">报销人：{{userName}}</p>
            <div class="row-info">
              出行方式：{{travelMode}}
            </div>
            <p class="row-info">出差天数：{{dateNums}}</p>
          </div>
          <div class="info-container-left-row">
            <p class="row-info">类型：{{reimbursementFormName}}</p>
            <p class="row-info">同行人数：{{peopleNum}}</p>
            <div class="row-info">
              补齐资料：
              <el-button type="text" class="btn-text" @click="lookImg(supplementDataImgList)"
                >详情</el-button
              >
            </div>
            <p class="row-info">是否上会：{{isSub}}</p>
          </div>
          <div class="info-container-left-row">
            <p class="row-info">部职级：{{rank}}</p>
            <div class="row-info bank-deposit">
              <div class="bank-content">
                <span class="row-bank">到达地点：</span>
                <span class="row-bank">{{address}}</span>
              </div>
            </div>
            <div class="row-info">
              上会资料：
              <el-button type="text" class="btn-text" @click="lookImg(subDataImgList)"
                >详情</el-button
              >
            </div>
            <div class="row-info bank-deposit">
              <div class="bank-content">
                <span class="row-bank">经费类型：</span>
                <span class="row-bank">{{reimbursementTypeDesc}}</span>
              </div>
            </div>
          </div>

          <div class="info-container-left-row">
            <p class="row-info">出差事由：{{reasonsForBusinessTrip}}</p>
            <p class="row-info">出差日期：{{date}}</p>
            <div class="row-info bank-deposit">
              <div class="remarks">
                <span class="row-bank">备注：</span>
                <el-tooltip class="item" :disabled="remarks.length < 9" effect="dark" :content="remarks" placement="top">
                  <span class="row-bank">{{remarks}}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="approval-container">
      <!-- 费用单 -->
      <div class="cost-container">
        <div class="cost-title">费用信息</div>
        <div class="cost-info-container">
          <div
            class="item-cost"
            v-for="(item, index) in costList"
            :key="index"
          >
            <div class="cost-sub-title">
              费用明细{{index+1}}
              <span
                v-if="item.isShowPurchaseMarkOrSalaryCostBill"
                :class="item.typeId == 36?'including-invoice':
                item.typeId == 37?'substitute-invoice':'salary-invoice'"
              >{{item.purchaseMarkOrSalaryCostBillName}}</span>
            </div>
            <div class="cost-info">
              <p class="cost-info-title">类型</p>
              <p class="cost-info-content">{{item.typeName}}</p>
              <p class="cost-info-title">日期</p>
              <p class="cost-info-content">{{item.date}}</p>
              <p class="cost-info-title">开支内容</p>
              <p class="cost-info-content expenditure-content">{{item.content}}</p>
              <div class="half-row">
                <div>
                  <p class="cost-info-title">金额（元）</p>
                  <p class="cost-info-content">￥{{item.amount}}</p>
                </div>
                <div class="half-row-right">
                  <p class="cost-info-title">核准金额（元）</p>
                  <div class="cost-info-content approved-amount">
                    ￥{{item.approvedAmount}}
                  </div>
                </div>
              </div>
              <div class="half-row">
                <div>
                  <p class="cost-info-title">附件</p>
                  <p class="cost-info-content look-img" @click="lookImg(item.imgList)">查看</p>
                </div>

                <div v-if="item.isSubstituteInvoiceOrSalaryInvoice"  class="half-row-right">
                  <p class="cost-info-title">{{item.substituteInvoiceOrSalaryInvoiceTitle}}</p>
                  <p class="cost-info-content look-img" @click="lookPurchaseOrSalaryInfo(item,item.typeId)">查看</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 资产信息 -->
      <div class="assets-info" v-if="assetsInfoList.length>0">
        <div class="assets-title">资产信息</div>
        <el-carousel
          trigger="click"
          :autoplay="false"
          :arrow="'always'"
          :loop="false"
        >
          <el-carousel-item
            v-for="(item, index) in assetsInfoList"
            :key="index"
          >
            <div class="assets-content">
              <div
                class="assets-name"
                v-for="(val, vIndex) in item.list"
                :key="vIndex"
              >
                <p class="assets-sub-title">资产明细{{vIndex+1+(index*2)}}</p>
                <div class="main-container">
                  <div class="assets-row">
                    <p>资产名称：{{val.name}}</p>
                    <p>资产编号：{{val.code}}</p>
                    <p>品牌：{{val.brand}}</p>
                    <p>规格型号：{{val.spec}}</p>
                  </div>
                  <div class="assets-row">
                    <p>价值（元）：{{val.price}}</p>
                    <p>取得日期：{{val.buyTime}}</p>
                    <p>折旧月数：{{val.useTimeLimit}}</p>
                    <p>所属部门：{{val.groupName}}</p>
                  </div>
                  <div class="assets-row">
                    <p>使用部门：{{val.departmentName}}</p>
                    <p>使用人：{{val.ownerName}}</p>
                    <p>坐落位置：{{val.locationName}}</p>
                    <p>购置理由：{{val.reason}}</p>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 流程进度 -->
      <div class="procedure">
        <div class="procedure-title">流程进度</div>
        <el-steps :active="activeSteps" align-center>
          <el-step :title="item.roleName" v-for="(item,index) in procedureList" :key="index">
            <template slot="title">
              <span>{{item.roleName}}</span>
              <img v-if="item.isOffline" src="../../../../assets/finance/files-sign.png" class="look-files" @click="lookImg(item.img)">
            </template>
            <template slot="description">
              <p class="procedure-description">{{item.name}}</p>
              <p class="procedure-description">{{item.date}}</p>
              <p class="procedure-description">{{item.remark}}</p>
            </template>
            <template slot="icon">
              <img class="circular" v-if="item.status == 3" src="../../../../assets/finance/circular.png">
              <img class="circular" v-else src="../../../../assets/finance/hign-circular.png">
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>

    <!-- 查看图片 -->
    <el-dialog
      :visible.sync="dialogLookImgVisible"
      class="look-img"
      >
      <el-carousel arrow="always" indicator-position="none" :autoplay="false" :loop="false">
        <el-carousel-item v-for="(item, index) in images" :key="index">
          <div v-if="!isNothingImg" class="img-container">
            <el-image
              class="img"
              :src="item"
              :preview-src-list="images">
            </el-image>
          </div>
          <div v-else class="nothing-container">
            <img class="nothimg-img" :src="item">
            <p class="nothing-text">当前暂未上传附件</p>
          </div>
          <div class="indicator">
            <span class="indicator-high">
              {{ index+1 }}
            </span>/
            <span>
              {{ images.length }}
            </span>
            <!-- <img class="nine-degree" @click="alongNineDegree" src="../../../../assets/finance/along-nine-degree.png"> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

    <!-- 伙食采购代发票 -->
    <el-dialog
      title="伙食采购代发票"
      width="880px"
      :visible.sync="dialogPurchaseSubstituteInvoiceInfoVisible"
      class="substitute-invoice-info"
    >
      <el-tabs v-model="selectOneDayPurchaseSubstituteInvoice" type="card">
        <el-tab-pane
          v-for="(item, index) in purchaseInfoList"
          :key="index"
          :label="item.createTime"
          :name="item.id"
        >
          <div class="table" v-if="item.tableData.length > 0">
            <el-table
              :data="item.tableData"
              :span-method="objectSpanMethod"
              min-height="40px"
              max-height="406px"
            >
              <el-table-column label="序号" width="80" prop="sort"></el-table-column>
              <el-table-column label="物料名称" min-width="150" prop="name" class-name="material-cell">
                <template slot-scope="scope">
                  <p v-if="!scope.row.isFlag">{{scope.row.name}}</p>
                  <div v-else class="supplier-class-high">
                    <span>
                      {{scope.row.supplierName}}
                    </span>
                    <span>
                      {{`小计：${scope.row.amount}`}}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.lable"
                :min-width="item.width"
                show-overflow-tooltip
              />
              <el-table-column label="金额（元）" width="180" class-name="sub-total-head" prop="amount">
                <template slot-scope="scope">
                  <p class="sub-total">{{scope.row.isFlag ? `小计：${scope.row.amount}`: scope.row.amount}}</p>
                </template>
              </el-table-column>
            </el-table>
            <div class="total-container">
              <span>合计</span>
              <div>
                <span class="check-total">({{item.checkTotalAmount}})</span>
                <span>{{item.totalAmount}}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 工薪单详情 -->
    <el-dialog
      title="工薪单详情"
      width="880px"
      :visible.sync="dialogSalaryBillVisible"
      class="substitute-invoice-info"
    >
      <el-tabs v-model="selectOneDaySalaryBill" type="card">
        <el-tab-pane
          v-for="(item, index) in salaryInfoList"
          :key="index"
          :label="item.title"
          :name="item.id"
        >
          <div class="table" v-if="item.tableData.length > 0">
            <el-table
              :data="item.tableData"
              min-height="40px"
              max-height="406px"
            >
              <el-table-column
                v-for="(item, index) in salaryTableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.lable"
                :min-width="item.width"
                show-overflow-tooltip
              />
              <el-table-column label="操作" width="120" >
                <template slot-scope="scope">
                  <el-button type="text" class="btn-text" @click="lookSalaryDatails(scope.row.id)"
                    >查看详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="total-container">
              <span>实发总金额</span>
              <span>{{item.totalAmount}}</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 工薪条详情 -->
    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :with-header="false"
    >
      <div class="drawer-title">
        <div class="user-info">
          <img class="user-avator" :src="detailsObj.img">
          <div>
            <p class="user-name">{{detailsObj.name}}</p>
            <p>{{detailsObj.rankZh}}</p>
            <div class="net-salary">
              <span class="net-salary-title">实发工资</span>
              <span>{{detailsObj.salary}}</span>
            </div>
          </div>
        </div>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div
        class="drawer-content"
        v-for="(item, index) in detailsObj.categoryList"
        :key="index"
      >
        <div class="category-title">{{item.name}}</div>
        <div class="category-content">
          <div
            v-for="(v, idx) in item.itemList"
            :key="idx"
            class="category-details"
          >
            <span>{{v.key}}：</span>
            <span>{{v.value}}</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  formatTimeToDate,
  formaTimeToMinute,
  handleAmount,
} from "@/common/js/utils.js";
import { statusMixins } from "@/common/mixins/status/status.js";
import { getTeamId } from "common/js/storage";
import FinanceApproval from "@/models/finance-approval.js";
import Salary from "@/models/salary.js";
export default {
  inject: ['reload'],
  mixins: [statusMixins],

  data() {
    return {
      id: '',
      orderType: '',
      userName: '',
      reimbursementFormName: '',
      billCode: '',
      billNum: '',
      travelMode: '',
      peopleNum: '',
      rank: '',
      reasonsForBusinessTrip: '',
      remarks: '',
      deptName: '',
      address: '',
      acceptorName: '',
      amount: '',
      date: '',
      needSupplementData: '',
      isSub: '',
      status: '',
      statusVal: '',
      bankAmount: 0,
      reimbursementTypeDesc: '',
      supplementDataImgList: [],
      subDataImgList: [],
      allApprovedAmount: 0,
      approvedAmount: 0,
      costList: [],
      activeSteps: 1,
      procedureList: [],
      assetsInfoList: [],
      dialogLookImgVisible: false,
      isNothingImg: false,
      dateNums: '',
      // 图片旋转角度
      deg: 0,
      images: [],
      type: 1,
      dialogVisible: false,
      financeMoreData: null,
      teamId: '',
      addCostList: [],
      timerId: null,
      purchaseOrSalaryCostBillObj: {
        36: '含发票',
        37: '代发票',
        38: '工薪单'
      },
      substituteInvoiceOrSalaryInvoiceTitleObj: {
        37: '伙食采购代发票',
        38: '工薪单详情'
      },
      dialogPurchaseSubstituteInvoiceInfoVisible: false,
      tableTitleList: [
        { prop: "unitType", lable: "单位", width: "90" },
        { prop: "nums", lable: "数量", width: "80" },
        { prop: "unitPrice", lable: "单价", width: "100" },
        { prop: "discount", lable: "优惠金额", width: "100" },
      ],
      selectOneDayPurchaseSubstituteInvoice: '1',
      purchaseInfoList: [],
      dialogSalaryBillVisible: false,
      selectOneDaySalaryBill: '1',
      salaryInfoList: [],
      salaryTableTitleList: [
        { prop: "name", lable: "姓名", width: "120" },
        { prop: "deptName", lable: "部门", width: "120" },
        { prop: "netSalary", lable: "实发工资", width: "120" },
      ],
      drawer: false,
      detailsObj: {
        img: '',
        name: '',
        rankZh: '',
        salary: '',
        categoryResList: []
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    let arr = ['approval', 'approvalDetails']
    if (arr.indexOf(to.name) !== -1) this.reload()
    next()
  },

  beforeCreate() {
    this.timerId = setTimeout(() => {
      this.$bus.emit('isShowTopMenu', false)
    })
  },

  created() {
    this.id = this.$route.query.id
    this.orderType = this.$route.query.type
    this.teamId = getTeamId()
    this.billCode = this.$route.query.billCode
    this.initDetails()
    this.initBillDetails()
    this.initFundAssetsDetails()
    this.initSubDataImgList()
    this.initSupplementDataImgList()
  },

  beforeDestroy() {
    clearTimeout(this.timerId)
  },

  methods: {
    initDetails() {
      if (this.orderType == 1) this.initFundDetails()
      if (this.orderType == 3) this.initBusinessDetails()
    },

    /* 经费结算单详情 */
    initFundDetails() {
      let id = this.id
      FinanceApproval.getFundDetails(id).then((res) => {
        if (res.success) {
          let { billNum, deptName, acceptorName, amount, status, date, isSub,
          approvalRecordList, reimbursementFormName, reimbursementTypeDesc,
           userName, needSupplementData, approvedAmount, bankAmount } = res.result
          this.billNum = billNum
          this.deptName = deptName
          this.acceptorName = acceptorName
          this.reimbursementFormName = reimbursementFormName
          this.needSupplementData = needSupplementData
          this.reimbursementTypeDesc = reimbursementTypeDesc
          this.amount = handleAmount(amount,2)
          this.bankAmount = handleAmount(bankAmount,2)
          this.allApprovedAmount = handleAmount(approvedAmount,2)
          this.date = formatTimeToDate(date)
          this.isSub = isSub?'是':'否'
          this.status = status
          this.statusVal = this.BILL_SEARCH_REIMBURSEMENT_STATUS[status]
          let procedureList = []
          approvalRecordList.map((i) => {
            let obj = {}
            obj.id = i.id
            obj.name = i.approverName
            obj.status = i.approvalRes
            obj.date = i.approvalTime != 0 ? formaTimeToMinute(i.approvalTime) : ''
            obj.img = i.picList
            obj.isOffline = i.isOffline
            obj.isSupplementData = i.isSupplementData
            obj.roleName = this.REIMBURSEMENT_ROLE_TYPE[i.roleType]
            obj.remark = `${this.REIMBURSEMENT_PROCEDURE_STATUS[i.approvalRes]}:${i.remark}`
            procedureList.push(obj)
          })
          let obj = {
            'name': userName,
            'roleName': '经办人',
            'date': formaTimeToMinute(date),
          }
          procedureList.unshift(obj)
          this.activeSteps = procedureList.findIndex((item) => {return item.status == 3 })
          this.procedureList = procedureList
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 差旅结算单详情 */
    initBusinessDetails() {
      let id = this.id
      FinanceApproval.getBusinessDetails(id).then((res) => {
        if (res.success) {
          let { billNum, acceptorName, amount, status, date, isSub,
          approvalRecordList, name, needSupplementData,reimbursementTypeDesc,
          formName, approvedAmount, beginTime, endTime, days, travelMode,
          peopleNum, province, city, district, rank, reasonsForBusinessTrip,
          remarks} = res.result;//bankAmount
          this.billNum = billNum
          this.acceptorName = acceptorName
          this.reimbursementFormName = formName
          this.travelMode = travelMode
          this.peopleNum = peopleNum
          this.rank = rank
          this.reasonsForBusinessTrip = reasonsForBusinessTrip
          this.reimbursementTypeDesc = reimbursementTypeDesc
          this.needSupplementData = needSupplementData
          this.amount = handleAmount(amount,2)
          // this.bankAmount = handleAmount(bankAmount,2)
          this.allApprovedAmount = handleAmount(approvedAmount,2)
          let startTime = formatTimeToDate(beginTime)
          let finishTime = formatTimeToDate(endTime)
          this.date = `${startTime}-${finishTime}`
          this.remarks = remarks
          this.userName = name
          this.isSub = isSub?'是':'否'
          this.status = status
          this.dateNums = days
          this.address = `${province}${city}${district}`
          this.statusVal = this.BILL_SEARCH_REIMBURSEMENT_STATUS[status]
          let procedureList = []
          approvalRecordList.map((i) => {
            let obj = {}
            obj.id = i.id
            obj.name = i.approverName
            obj.status = i.approvalRes
            obj.date = i.approvalTime != 0 ? formaTimeToMinute(i.approvalTime) : ''
            obj.img = i.picList
            obj.isOffline = i.isOffline
            obj.isSupplementData = i.isSupplementData
            obj.roleName = this.REIMBURSEMENT_ROLE_TYPE[i.roleType]
            obj.remark = `${this.REIMBURSEMENT_PROCEDURE_STATUS[i.approvalRes]}:${i.remark}`
            procedureList.push(obj)
          })
          let obj = {
            'name': name,
            'roleName': '经办人',
            'date': formaTimeToMinute(date),
          }
          procedureList.unshift(obj)
          this.activeSteps = procedureList.findIndex((item) => {return item.status == 3 })
          this.procedureList = procedureList
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 经费结算单关联的资产列表 */
    initFundAssetsDetails() {
      let id = this.id
      FinanceApproval.getFundAssetsDetails(id).then((res) => {
        if (res.success) {
          let arr = []
          res.result.map((i,index) => {
            if (((index+1)%2) !=0) {
              arr.push({list: [i]})
            } else {
              let len = arr.length-1
              arr[len].list.push(i)
            }
          })
          this.assetsInfoList = arr
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 费用单详情列表 */
    initBillDetails() {
      let orderId = this.id
      let teamId = this.teamId
      let orderType = this.orderType
      let data = {
        orderId,
        teamId,
        orderType
      }
      FinanceApproval.postBillDetails(data).then((res) => {
        if (res.success) {
          let costList = []
          const purchaseOrSalaryCostBillTypeId = [36,37,38]
          res.result.map(i => {
            let obj = {}
            obj.billId = i.billId
            obj.date = formatTimeToDate(i.date)
            obj.billType = i.billType
            obj.typeName = i.typeName
            obj.amount = handleAmount(i.amount,2)
            obj.approvedAmount = handleAmount(i.approvedAmount,2)
            obj.content = i.expenditureContent
            obj.receiptList = i.receiptList
            obj.typeId = i.typeId
            // 是否是采购发票和工薪单
            let isShowPurchaseMarkOrSalaryCostBill = purchaseOrSalaryCostBillTypeId.indexOf(i.typeId) !== -1 ? true : false
            obj.isShowPurchaseMarkOrSalaryCostBill = isShowPurchaseMarkOrSalaryCostBill
            // 采购代发票和工薪单标记
            obj.isSubstituteInvoiceOrSalaryInvoice = isShowPurchaseMarkOrSalaryCostBill && (i.typeId == 37 || i.typeId == 38)
            obj.purchaseMarkOrSalaryCostBillName = this.purchaseOrSalaryCostBillObj[i.typeId]
            obj.substituteInvoiceOrSalaryInvoiceTitle = this.substituteInvoiceOrSalaryInvoiceTitleObj[i.typeId]
            obj.imgList = []
            i.receiptList.map(v => {
              if (v.picUrl.length>0) {
                obj.imgList = obj.imgList.concat(v.picUrl)
              }
            })
            costList.push(obj)
          })
          this.costList = costList
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 补齐资料图片集合 */
    initSupplementDataImgList() {
      let id = this.id
      let orderType = this.orderType
      let data = {
        id,
        orderType
      }
      FinanceApproval.getSupplementDataImgList(data).then((res) => {
        if (res.success) {
          this.supplementDataImgList = res.result
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 上会资料图片集合 */
    initSubDataImgList() {
      let id = this.id
      let orderType = this.orderType
      let data = {
        id,
        orderType
      }
      FinanceApproval.getSubDataImgList(data).then((res) => {
        if (res.success) {
          this.subDataImgList = res.result
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 采购代发票明细 */
    initPurchaseSubsitutionInvoiceInfo(billId, billType) {
      FinanceApproval.getPurchaseList(billId, billType).then((res) => {
        if (res.success) {
          let arr = []
          res.result.map((j, index) => {
            let purchaseObj = {}
            purchaseObj.id = String(index+1)
            purchaseObj.totalAmount = handleAmount(j.totalPrice,2)
            purchaseObj.checkTotalAmount = handleAmount(j.checkTotalPrice,2)
            purchaseObj.createTime = j.date
            purchaseObj.tableData = []
            let sort = 1
            j.detailList.map(i => {
              i.elementList.map((v, index) => {
                let obj = {}
                obj.sort = sort++
                obj.detailId = v.detailId
                obj.materialId = v.materialId
                obj.name = v.materialName
                obj.nums = handleAmount(v.checkNum,2)
                obj.discount = v.discount? handleAmount(v.discount,2) : ''
                obj.unitType = this.UNIT[v.unitType]
                obj.unitPrice = handleAmount(v.checkUnitPrice,2)
                obj.amount = handleAmount(v.checkSubtotal,2)
                obj.isFlag = 0
                purchaseObj.tableData.push(obj)
                if (index == i.elementList.length-1) {
                  let obj2 = {}
                  obj2.sort = ''
                  obj2.detailId = ''
                  obj2.materialId = ''
                  obj2.name = ''
                  obj2.nums = ''
                  obj2.unitType = ''
                  obj2.discount = ''
                  obj2.amount = handleAmount(i.checkTotalPrice,2)
                  obj2.supplierName = `供应商：${i.supplierName}`
                  obj2.isFlag = 1
                  purchaseObj.tableData.push(obj2)
                }
              })
            })
            arr.push(purchaseObj)
          })
          this.purchaseInfoList = arr
          this.dialogPurchaseSubstituteInvoiceInfoVisible = true
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 工薪单详情 */
    initSalaryBill(billId) {
      FinanceApproval.getSalaryBillList(billId).then((res) => {
        if (res.success) {
          let arr = []
          res.result.map((j, index) => {
            let obj = {}
            obj.id = String(index+1)
            obj.payrollId = j.id
            obj.totalAmount = handleAmount(j.totalAmount,2)
            obj.title = j.title
            obj.tableData = []
            j.paySlipResVoList.map(i => {
              let obj2 = {}
              obj2.id = i.id
              obj2.name = i.name
              obj2.deptName = i.thirdDeptName
              obj2.netSalary = handleAmount(i.salary,2)
              obj.tableData.push(obj2)
            })
            arr.push(obj)
          })
          this.salaryInfoList = arr
          this.dialogSalaryBillVisible = true
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取工资条详情 */
    initPayslipDetails(id) {
      Salary.getPaySlipDetials(id).then(res => {
        if (res.success) {
          let { img, name, rankZh, salary, categoryList} = res.result
          this.detailsObj.img = img
          this.detailsObj.name = name
          this.detailsObj.rankZh = rankZh
          this.detailsObj.salary = handleAmount(salary,2)
          let arr = []
          categoryList.map(i => {
            let obj = {}
            obj.name = i.name
            obj.itemList = []
            i.itemList.map(v => {
              let obj2 = {}
              obj2.key = v.key
              obj2.value = handleAmount(v.value,2)
              obj.itemList.push(obj2)
            })
            arr.push(obj)
          })
          this.detailsObj.categoryList = arr
          this.drawer = true
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    lookImg(v) {
      if (v.length > 0) {
        this.images = v
        this.$viewerApi({
          images: v,
        })
      } else {
        this.$message({
          type: "error",
          message: '暂无图片',
        });
      }
      // this.dialogLookImgVisible = true
      // if (v.length > 0) {
      //   this.images = v
      //   this.isNothingImg = false
      // } else {
      //   let img = require('../../../../assets/nothing/nothig-img.png')
      //   this.images = [img]
      //   this.isNothingImg = true
      // }
    },

    /* 顺90度旋转 */
    alongNineDegree() {
      this.$nextTick(() => {
        this.deg += 90;
        if (this.deg >= 360) this.deg = 0;
      })
    },

    printPreview() {
      let orderId = this.id
      let type = this.orderType
      FinanceApproval.printPreview(type, orderId).then((res) => {
        if (res.success) {
          window.open(res.result)
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    lookPurchaseOrSalaryInfo(row, typeId) {
      let billId = row.billId
      let billType = row.billType
      if (typeId !== 38) {
        this.initPurchaseSubsitutionInvoiceInfo(billId, billType)
      } else {
        this.initSalaryBill(billId)
      }
    },

    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.isFlag) {
        if (columnIndex === 1) {
          return [1, 7];
        } else {
          return [0, 0];
        }
      }
    },

    lookSalaryDatails(id) {
      this.initPayslipDetails(id)
    },

    /* 关闭抽屉 */
    closeDrawer() {
      this.drawer = false;
    },
  }
}
</script>

<style lang='scss'>
.agent-detials {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: $bg-WhiteSmoke;
  .top-container {
    background: $bg-white;
    padding: 19px 20px 12px 20px;
    .code {
      font-size: 20px;
      font-weight: bold;
      color: $color-BlackGrey;
    }
    .operation {
      @include flex-between;
      align-items: flex-start;
      .operation-right {
        width: 399px;
        @include flex-between;
        align-items: flex-start;
        .row-title {
          height: 24px;
          text-align: right;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-LightGrey;
        }
        .row-content {
          height: 24px;
          text-align: right;
          font-size: $fs-medium-l;
          font-weight: bold;
          color: $color-BlackGrey;
        }
        .row-amount {
          font-size: $fs-medium-m;
        }
      }
      .print-sign {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
    }
    .info-container {
      @include flex-start;
      .info-container-left {
        width: 70%;
        .info-container-left-row {
          @include flex-start;
          .row-info {
            width: 25%;
            height: 32px;
            text-align: left;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-BlackGrey;
            .el-icon-edit {
              color: $color-DeepReddishBlue;
            }
            .el-button {
              padding: 0px;
            }
            .row-bank {
              line-height: 16px;
            }
          }
          .bank-deposit {
            @include flex-start;
            align-items: flex-start;
            .bank-content {
              height: 100%;
              margin-right: 6px;
              @include two-wrap-ellipsis(2);
            }
            .remarks {

              @include two-wrap-ellipsis(1);
            }
          }
        }
      }
    }
  }
  .approval-container {
    padding: 20px;
    flex: 1;
    .cost-container {
      background: $bg-white;
      margin-bottom: 20px;
      .cost-title {
        font-size: $fs-medium-s;
        font-weight: 400;
        color: $color-BlackGrey;
        height: 56px;
        line-height: 56px;
        text-align: left;
        padding-left: 21px;
        border-bottom: 1px solid $bg-ShallowLightSnow;
      }
      .cost-info-container {
        min-height: 360px;
        padding: 20px;
        @include flex-start;
        box-sizing:  border-box;
        overflow-x: auto;
        .item-cost {
          width: 273px;
          text-align: left;
          border: 1px solid $bg-ShallowLightSnow;
          margin-right: 20px;
          box-sizing: border-box;
          .cost-sub-title {
            padding: 0px 20px 0px 19px;
            height: 44px;
            line-height: 44px;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-BlackGrey;
            border-bottom: 1px solid $bg-ShallowLightSnow;
            @include flex-between;
            .including-invoice,
            .substitute-invoice,
            .salary-invoice {
              width: 52px;
              height: 22px;
              line-height: 22px;
              text-align: center;
              font-size: $fs-small-m;
              font-weight: 400;
              border-radius: 4px;
            }
            .including-invoice {
              background: rgba(24, 144, 255, 0.08);
              border: 1px solid $color-DepartmentPeople;
              color: $color-DeepReddishBlue;
            }
            .substitute-invoice {
              background: rgba(255, 136, 0, 0.08);
              border: 1px solid $color-OriginYellow;
              color: $color-OriginYellow;
            }
            .salary-invoice {
              background: rgba(7, 169, 61, 0.08);
              border: 1px solid $bg-green;
              color: $bg-green;
            }
          }
          .cost-info {
            width: 273px;
            padding: 15px 19px;
            box-sizing: border-box;
            .cost-info-title {
              min-height: 24px;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-LightGrey;
              line-height: 24px;
            }
            .cost-info-content {
              min-height: 24px;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-BlackGrey;
              line-height: 24px;
            }
            .expenditure-content {
              @include two-wrap-ellipsis(3);
            }
            .half-row {
              @include flex-between;
              .approved-amount {
                @include flex-between;
              }
              .half-row-right {
                width: 51%;
              }
              .look-img {
                padding-right: 20px;
              }
            }
            .look-img {
              cursor: pointer;
              color: $color-DeepReddishBlue;
            }
          }
        }
        .item-cost:nth-last-child(1) {
          margin-right: 0px;
        }
      }
    }
    .procedure {
      background: $bg-white;
      .circular {
        width: 8px;
        height: 8px;
      }
      .procedure-title {
        font-size: $fs-medium-s;
        font-weight: 400;
        color: $color-BlackGrey;
        height: 56px;
        line-height: 56px;
        text-align: left;
        padding-left: 21px;
        border-bottom: 1px solid $bg-ShallowLightSnow;
      }
      .el-steps {
        padding-top: 20px;
        padding-bottom: 17px;
        .el-step__icon.is-text {
          border: none;
        }
      }
      .procedure-description {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
      }
      .look-files {
        width: 14px;
        height: 16px;
        margin-left: 7px;
        cursor: pointer;
        vertical-align: text-top;
      }
      .el-step__title.is-finish {
        color: $color-BlackGrey;
        font-weight: 700;
      }
      .el-step__title.is-wait,
      .el-step__title.is-process {
        color: $color-LightGrey;
        font-weight: 400;
      }
    }
    .assets-info {
      background: $bg-white;
      margin-bottom: 20px;
      overflow: hidden;
      .assets-title {
        font-size: $fs-medium-s;
        font-weight: 400;
        color: $color-BlackGrey;
        height: 56px;
        line-height: 56px;
        text-align: left;
        padding-left: 21px;
        border-bottom: 1px solid $bg-ShallowLightSnow;
      }

      .el-carousel--horizontal {
        overflow-x: visible;
      }
      .el-carousel__container {
        min-height: 382px;
      }
      .el-carousel__button {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: $bg-SpotGray;
      }
      .el-carousel__arrow {
        width: 16px;
        height: 16px;
        font-size: $fs-medium-s;
        transform: none;
        top: -33px;
        color: $bg-Gainsboro;
        background: transparent;
      }
      .el-carousel__arrow:hover {
        color: $color-DepartmentPeople;
      }
      .el-carousel__arrow--left {
        left: inherit;
        right: 50px;
      }
      .el-carousel__item {
        padding: 20px;
        box-sizing: border-box;
      }
      .assets-name {
        border: 1px solid $bg-ShallowLightSnow;
        margin-bottom: 20px;
        .assets-sub-title {
          height: 44px;
          line-height: 44px;
          text-align: left;
          padding-left: 21px;
          background: #FCFCFC;
          border-bottom: 1px solid $bg-ShallowLightSnow;
        }
        .main-container {
          padding: 20px 20px 16px 20px;
          .assets-row {
            @include flex-start;
            p {
              width: 25%;
              height: 24px;
              text-align: left;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-BlackGrey;
            }
          }
        }
      }
    }
  }
  .look-img {
    .el-dialog {
      width: 522px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      margin: 0;
      width: 522px;
      height: 522px;
      box-sizing: border-box;
      .el-carousel {
        width: 100%;
        height: 100%;
        .el-carousel__container {
          height: 100%;
          .img-container,
          .nothing-container {
            width: 100%;
            height: 478px;
          }
          .img-container {
            overflow: hidden;
          }
          .img {
            width: 100%;
            height: 100%;
          }
          .nine-degree {
            width: 16px;
            height: 16px;
            margin-left: 10px;
          }
          .nothing-container {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          }
          .nothimg-img {
            width: 119px;
            height: 115px;
          }
          .nothing-text {
            font-size: $fs-small-l;
            font-weight: 400;
            margin-top: 40px;
            color: $color-LightGrey;
          }
          .indicator {
            width: 100%;
            height: 44px;
            color: #999;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            .indicator-high {
              color: #333;
            }
          }
        }
      }
    }
  }
  .substitute-invoice-info {
    .el-dialog__body {
      padding: 20px;
      .el-tabs--card {
        padding-top: 9px;
        border: 1px solid $bg-ShallowLightSnow;
        .el-tabs__header {
          margin-bottom: 20px;
          .el-tabs__nav-wrap {
            .el-tabs__nav-scroll {
              padding: 0px 20px;
            }
          }
          .el-tabs__nav-wrap.is-scrollable {
            .el-tabs__nav-scroll {
              padding: 0px;
            }
          }
        }
        .el-tabs__content {
          padding: 0px 20px 20px 18px;
          .table {
            .material-cell {
              .cell {
                padding-left: 0px;
              }
            }
            .sub-total-head {
              text-align: right;
              padding-right: 30px;
              .sub-total {
                padding-right: 30px;
              }
            }
            .supplier-class-high,
            .total-container {
              display: flex;
              justify-content: space-between;
              padding-right: 60px;
              padding-left: 16px;
              background: $bg-ChangeDepartmentTree;
            }
            .total-container {
              height: 44px;
              align-items: center;
              font-size: $fs-medium-s;
              font-weight: bold;
              color: $color-BlackGrey;
              border-left: 1px solid #F2F4F8;
              border-right: 1px solid #F2F4F8;
              border-bottom: 1px solid #F2F4F8;
              .check-total {
                color: $color-OriginYellow;
              }
            }
          }
        }
      }
    }
  }
  .el-drawer__wrapper {
    top: 56px !important;
  }
  .user-info {
    @include flex-between;
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
    text-align: left;
    .user-avator {
      width: 40px;
      height: 40px;
      margin-right: 24px;
    }
    .user-name {
      font-size: $fs-medium-s;
      font-weight: bold;
      color: $color-BlackGrey;
      margin-bottom: 11px;
    }
    .net-salary {
      margin-top: 12px;
      .net-salary-title {
        margin-right: 22px;
      }
    }
  }
  .drawer-title {
    align-items: flex-start;
    margin-bottom: 16px;
  }
  .drawer-content {
    width: 360px;
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
    text-align: left;
    margin-bottom: 16px;
    .category-title {
      margin-bottom: 12px;
    }
    .category-content {
      padding: 16px 13px;
      background: $bg-ChangeDepartmentTree;
      .category-details {
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
.viewer-backdrop {
  background-color: rgba(0, 0, 0, 50%)!important;
}
.viewer-list {
  width: 100%;
  height: 120px;
  display: flex;
  li {
    flex-shrink: 0;
    width: 120px;
    height: 120px;
    img {
      transform: translateX(0px)!important;
      width: 120px!important;
      height: 120px!important;
    }
  }
}
.viewer-loading::after {
  border: 4px solid rgba(255, 255, 255, 10%);
  border-left-color: rgba(255, 255, 255, 50%);
}
.viewer-button:focus, .viewer-button:hover {
  background: rgba(0, 0, 0, 80%);
}
</style>
